import { takeEvery, put, delay, select, race, call } from 'redux-saga/effects'
import { getSingleCompany } from '../../lib/requests/routesRequests'
import { delays } from '../../lib/constants'
import { getCurrentLang, getToken, getDicionary } from '../selectors'

export function* worker({ hash }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(getSingleCompany, token, currentLang, hash),
      timeout: delay(delays.forCancelRequest),
    })
    if (result && result.status === 200) {
      yield put({
        type: 'SET_COMPANY_INFO',
        payload: result.data.data,
      })
    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
      yield put({ type: 'SET_COMPANY_BADREQEST', payload: true })
    }
  } catch (e) {
    yield put({ type: 'SET_COMPANY_BADREQEST', payload: true })
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* singleRoute() {
  yield takeEvery('SAGA_GET_COMPANY_INFO', worker)
}
